import React, { useEffect, useState, useRef } from 'react'
import ExcelExport from '../ExcelExport'
import { Link, useNavigate } from 'react-router-dom';
import { optionProductsByProducts, provinces } from '../Options';
import Multiselect from 'multiselect-react-dropdown';
import Sidebar from '../Sidebar';
// import env from 'react-dotenv'

export default function KCASpotRateTable() {

    const [prices, setPrices] = useState([])
    const [filteredPrices, setFilteredPrices] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [todayMessage, setTodayMessage] = useState('Show todays values')
    
     //Pagination
    const [page, setPage] = useState(1)
    const [postsPerPage, setPostsPerPage] = useState(20)
    const getPrices = async ()=> {
        const token = sessionStorage.getItem('token')
        const response = await fetch(`${process.env.REACT_APP_API_URL}/getKCA`,{
          headers: {
            'x-access-token': token
          }
        })
        const pricelist = await response.json()
        pricelist.sort((a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          return dateB - dateA;
        });
        setPrices(pricelist)
       // console.log(prices)
    }

    const totalPages = Math.ceil(prices.length / postsPerPage);
    const pageRange = 10; // Number of page buttons to show at a time

    const startPage = Math.max(1, page - Math.floor(pageRange / 2));
    const endPage = Math.min(totalPages, startPage + pageRange - 1);

    const pageButtons = [...Array(endPage - startPage + 1)].map((_, i) => startPage + i);
    useEffect(()=>{
        getPrices()
    }, [])

    
    const lastPostIndex = page*postsPerPage
    const firstPostIndex = lastPostIndex - postsPerPage
    const currentPrices = prices.slice(firstPostIndex, lastPostIndex)
    const selectPageHandler =(selectedPage)=>{
      setPage(selectedPage)
    }

    
    

    //The Delete Button
    const handleDelete = async (itemId) =>{
      const fL = prices.filter((filteredPrice) => filteredPrice._id !== itemId)
      const token = sessionStorage.getItem('token')
      await fetch(`${process.env.REACT_APP_API_URL}/delete-kca/${itemId}`,{
          method:'DELETE',
          headers: {
              'Content-Type':'application/json',
              'x-access-token':token
          }
      })
        // .then(console.log("Delete successfull"))
    setPrices(fL)
  }

  
  //edit page
  const navigate = useNavigate()
  //Edit page
  const handleEdit = async (itemId) =>{
    navigate(`/updatelintcotton/${itemId}`)
   // console.log("In the button")
  }



  return (
    <>
        <div className="sidebar">
    <Sidebar/>
    <h2 id='tabler'>KCA Spot Rate</h2>
    </div>
   
        <div id='tabler1'>


        <div className='tables-option-div'>
      <div className="row">

        <div className="col">
        <div className="tables-options">
        <ExcelExport excelData={prices} fileName={'PricesSheet'} />

        </div>
        </div>

        <div className="col">
          <div className="tables-options">
          <Link to='/kca-spot-rate-form'> <button type="button" class="btn btn-secondary table-buttons">  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-square-fill" viewBox="0 0 16 16">
  <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z"/>
</svg>   Create New</button></Link>
          </div>
        </div>
      </div>            
      </div>
          
          {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1>KCA Spot Rate</h1>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
        <div style={{ marginBottom: '10px', padding:"30px 30px 30px 30px"}}>
          <ExcelExport excelData={prices} fileName={'PricesSheet'} />
        </div>
        <div style={{ marginBottom: '10px', padding:"30px 10px 30px 10px"}}>
        <Link to='/kca-spot-rate-form'> <button type="button" class="btn btn-secondary">  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-square-fill" viewBox="0 0 16 16">
  <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z"/>
</svg>   Create New</button></Link>
        </div> 
        </div>
          
             
      </div>   */}

      <table class="table" id="table1">

  <thead>
    <tr>
      <th scope="col">Date</th>
      <th scope="col">Ex-Ginning Prices</th>
      <th scope="col">Ex-Spot Rates</th>
      <th scope="col">Clbs</th>
      {/* <th scope="col">Loosing</th>
      <th scope="col">Gaining</th>
      <th scope="col">Crop</th> */}
      <th scope="col">Delete</th>
      <th scope="col">Edit</th>
    </tr>
  </thead>

  <tbody>
  
      {currentPrices && currentPrices.map((price, index) =>(
            <tr key={price._id}>
                <td>{new Date(price.date).toLocaleDateString('en-US')}</td>
                <td>{price.exGinningPrices}</td>
                <td>{price.exSpotRatesKarachi}</td>
                <td>{price.clbs}</td>
                {/* <td>{price.loosing}</td>
                <td>{price.gaining}</td>
                <td>{price.crop}</td> */}
                <td><button type="button" class="btn btn-danger" onClick={()=>handleDelete(price._id)}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/> <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/></svg></button></td>
                <td>  <Link type="button" class="btn btn-info" to={`/update-KCA/${price._id}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16"><path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/><path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/></svg></Link></td>
            </tr>
      ))}
  </tbody>
  
</table>


{currentPrices.length > 0 && (
  <div className="pagination">
    <br />
    {pageButtons.map((pageNumber) => (
      <button
        type="button"
        id="num-but"
        class="btn btn-secondary btn-lg mb-2"
        onClick={() => selectPageHandler(pageNumber)}
        key={pageNumber}
      >
        {pageNumber}
      </button>
    ))}
    <br />
    {/**Fixing the date issue */}
  </div>
)}
{!prices && <div class="alert alert-primary" role="alert">
  Oops! Something went wrong.
</div>}


    </div>
    
    </>
    
  )


  
}


